// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseVerticalList-wrapper-zRzLthBSt2","item":"BaseVerticalList-item-2NanPVanhr","border":"BaseVerticalList-border-2_4WERze77"};